module.exports = __webpack_public_path__ + "static/img/btn_yuyuechenggong_nor.248b7a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_yuyuechenggong_nor.png
// module id = +FQV
// module chunks = 1